// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".f15c5637ec460ce0ab74a34ab73969ebea45690e.chunk.bundle.js";
};